"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    TEXT: 'text',
    RICH_TEXT: 'rich_text',
    STATIC: 'static',
    BOOLEAN: 'boolean',
};
